import { Directive, Input } from "@angular/core";
import {
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
} from "@angular/forms";
import { BaseValidator } from "../../../modules/tcm-core.module";
import { TranslationService } from "src/app/services";

@Directive({
    selector: "[geoCoordinateValidator]",
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: GeoCoordinateValidator,
            multi: true,
        },
    ],
    standalone: false
})
export class GeoCoordinateValidator extends BaseValidator {
  private data;
  @Input() public get geoCoordinateValidator(): {
    type: string;
  } {
    return this.data;
  }

  public set geoCoordinateValidator(value: { type: string }) {
    this.data = value;
    if (this._onChange) this._onChange();
  }
  constructor(private translationService: TranslationService) {
    super("geoCoordinateNotValid");
  }

  protected getValidationResult(control: AbstractControl): ValidationErrors {
    if (!control.value || !control.dirty) {
      return null;
    }
    let result = {} as any;
    if (this.data && this.data.type == "lat") {
      if (parseFloat(control.value) >= -90 && parseFloat(control.value) <= 90) {
        return null;
      } else {
        result.error = this.translationService.translate(x => x.Messages.ValidationMessages.GeoCoordinateLatitudeNotValid);
        return this.buildValidationErrorResult(result);
      }
    }else{
      if (parseFloat(control.value) >= -180 && parseFloat(control.value) <= 180) {
        return null;
      } else {
        result.error = this.translationService.translate(x => x.Messages.ValidationMessages.GeoCoordinateLongitudeNotValid);
        return this.buildValidationErrorResult(result);
      }
    }
  }
}
